import React from 'react'

const Main = (props) => {
  return (
    <div className="main-wrapper">
        {props.children}
    </div>
  )
}

export default Main